import {GrupoCarteira} from "./carteira.model";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {catchError, retry} from "rxjs/operators";

import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {handleError} from "../shared/util/error-util";

@Injectable({
  providedIn: 'root'
})
export class GrupoCarteiraService{

  private readonly httpHeaders = new HttpHeaders({'Content-Type': 'application/json'});

  url = "/v1/grupo-carteiras";

  constructor(private readonly http: HttpClient) {
  }

  findAllByGroup(nome: string): Observable<GrupoCarteira> {
    const headers = this.httpHeaders;
    const options = {headers};
    return this.http.get<GrupoCarteira>(`${this.url}/nome/${encodeURIComponent(nome)}`, options).pipe(catchError(handleError));
  }
}
